import FormFieldConstructor from './form-field-constructor';

export default FormFieldConstructor;